import { render, staticRenderFns } from "./CredenciamentoVisualizacao.vue?vue&type=template&id=18b5b4fa&"
import script from "./CredenciamentoVisualizacao.vue?vue&type=script&lang=js&"
export * from "./CredenciamentoVisualizacao.vue?vue&type=script&lang=js&"
import style0 from "./CredenciamentoVisualizacao.vue?vue&type=style&index=0&id=18b5b4fa&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports